<template>
  <div id="primary" class="content-area">
    <main id="main" class="site-main">
      <article class="twentyseventeen-panel page type-page status-publish hentry">
        <swiper :options="swiperOption">
         <!--  <swiper-slide style="background:#eee;">
            <div class="content">
              <img style="width:40vw;left:0;top:10%;" :src="swiperDesc.ezb" />
              <img style="width:35vw;right:0;top:5%;" src="images/swiper/2-1.png" />
              <img style="width:35vw;right:10%;top:50%;" src="images/swiper/2-2.png" />
              <div style="left:0;top:45%;font-size:40px;max-width:40vw;">
                {{ $t('swiper._1[0]') }}
                <router-link to="/products/ezb">{{ $t('swiper._1[1]') }}</router-link>
              </div>
            </div>
          </swiper-slide>

          <swiper-slide style="background:#fff;">
            <div class="content">
              <img style="width:40vw;left:0;top:60%;" :src="swiperDesc.syx" />
              <img style="width:38vw;left:0;top:7%;" src="images/swiper/3-1.png" />
              <img style="width:38vw;right:0;top:7%;" src="images/swiper/3-2.png" />
              <div style="left:60%;top:60%;font-size:40px;">
                {{ $t('swiper._2[0]') }}
                <router-link to="/products/syx">{{ $t('swiper._2[1]') }}</router-link>
              </div>
            </div>
          </swiper-slide> -->

<!--           <swiper-slide style="background:#eee;">
            <div class="content">
              <img style="width:40vw;left:0;top:10%;" :src="swiperDesc.eyxp" />
              <img style="width:45vw;right:0;top:38%;" src="images/swiper/2p-1.png" />
              <div style="left:0;top:45%;font-size:40px;max-width:40vw;">
                {{ $t('swiper._3[0]') }}
                <router-link to="/products/eyxp">{{ $t('swiper._3[1]') }}</router-link>
              </div>
            </div>
          </swiper-slide> -->
          <swiper-slide style="background:#eee;">
            <div class="content">
              <img style="width: 40vw; left: 40vw; top: 10%;" :src="swiperDesc._13" />
              <img style="width: 36vw; left: 0px; top: 5%;" src="/images/swiper/S02.png" /> 
              <img style="width: 38vw; left: 0px; top: 52%;" src="/images/swiper/S03.png" /> 

              <div style="left: 40vw; top: 50%; font-size: 30px;">
                {{ $t('swiper._1[0]') }}
                <div style="display: flex; align-items: center; ">
                <router-link to="/products/s02">S02 PRO</router-link>
                <router-link to="/products/s03" style="margin-left:2vw;" >S03 PRO</router-link>
                </div>
              </div>
            </div>
          </swiper-slide>  


          <swiper-slide style="background:#fff;">
            <div class="content">
              <img style="width:40vw;left:40vw;top:10%;" :src="swiperDesc.dyx" />
              <img style="width:38vw;left:0;top:5%;" src="/images/swiper/1-1.png" />
              <img style="width:38vw;left:0;top:55%;" src="/images/swiper/1-2.png" />
              <div style="left:40vw;top:50%;font-size:40px;">
                {{ $t('swiper._2[0]') }}
                <router-link to="/products/five">{{ $t('swiper._2[1]') }}</router-link>
              </div>
            </div>
          </swiper-slide>



          <swiper-slide style="background:#fff;">
            <div class="content">
              <img style="width: 38vw; left: 5vw; top: 50%;" src="/images/swiper/4-3.png" />
              <img style="width: 38vw; left: 0px; top: 5%;" src="/images/swiper/4-4.png" />
              <!-- <img style="width:24vw;left:56vw;top:36%;" src="images/swiper/4-0.png" /> -->
              <video data-v-6735128d="" controls="controls" autoplay="autoplay" style="width: 40vw; left: 44vw; top: 28%;"><source  src="//fs.lizheng.design/static/home.mp4" type="video/mp4">
              您的浏览器不支持 video 标签。
            </video>
              <div style="display: flex; align-items: center; left: 44vw; top: 5%; font-size: 30px;">
                {{ $t('swiper._3[0]') }}
                <router-link to="/products/glb_video" style="margin: 0px 0px 0px 2vw;">{{ $t('swiper._3[1]') }}</router-link>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </article>
    </main>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false
        // },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {
    document.body.className = "home page-template-default page twentyseventeen-front-page page-one-column colors-light";
    this.$forceUpdate();
    this.$nextTick(() => {
      this.setSwiperHeight();
    });
    window.onresize = () => {
      this.setSwiperHeight();
    };
  },
  methods: {
    setSwiperHeight() {
      const swiperContainer = document.querySelector(".swiper-container");
      if (!swiperContainer) return;
      const swiperScale = 700 / 1680;
      const swiperWidth = swiperContainer.clientWidth;
      const windowWidth = window.innerWidth;
      if (windowWidth < 1680) {
        swiperContainer.style.height = swiperWidth * swiperScale + "px";
      } else {
        swiperContainer.style.height = "700px";
      }
    }
  },
  computed: {
    swiperDesc() {
      let srcLan=this.$i18n.locale ;
      if(srcLan.indexOf('en')!=-1){
          srcLan='en';
      }else{
          srcLan='zh';
      }
      return {
        dyx: require(`@/assets/images/swiper/1-${srcLan}.png`),
        _13: require(`@/assets/images/swiper/1.3-${srcLan}.png`)
      };
    }
  }
};
</script>
<style lang="stylus" scoped>
.page {
  width: 100%;
}

.swiper-container {
  max-height: 700px;
}

.swiper-slide {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .content {
    position: relative;
    margin: 0 auto;
    width: 80%;
    height: 100%;
    color: #666;

    div, img {
      display: block;
      position: absolute;
    }
    div, video {
      display: block;
      position: absolute;
    }
    a {
      display: block;
      margin-top: 40px;
      padding: 10px 0;
      text-align: center;
      color: #fff;
      cursor: pointer;
      font-size: 28px;
      background: #808080;
      width: 160px;

      &:hover {
        background: #00b2f3;
      }
    }
  }
}

@media (max-width: 768px) {
  .swiper-container {
    max-height: 400px;
  }

  .swiper-slide {
    .content {
      width: 90%;

      a {
        font-size: 18px;
        width: 120px;
        margin-top: 20px;
      }

      div {
        font-size: 18px !important;
      }
    }
  }
}

@media (max-width: 480px) {
  .swiper-container {
    max-height: 280px;
  }

  .swiper-slide {
    .content {
      a {
        font-size: 14px;
        width: 100px;
        padding: 6px 0;
      }

      div {
        font-size: 14px !important;
      }
    }
  }
}
</style>

